import React from 'react';
import { ResponsiveGrid } from '@alifd/next';
import PageHeader from '@/components/PageHeader';
import PostalserviceSearchList from './components/PostalserviceSearchList';

const { Cell } = ResponsiveGrid;

const PostalserviceSearch = () => (
  <ResponsiveGrid gap={20}>
    <Cell colSpan={12}>
      <PageHeader
        title="郵務查詢列表"
        // description="行事曆列表"
        breadcrumbs={[
          {
            name: '郵件包裹',
          },
          {
            name: '郵務查詢列表',
          },
        ]}
      />
    </Cell>

    <Cell colSpan={12}>
      <PostalserviceSearchList />
    </Cell>
  </ResponsiveGrid>
);

export default PostalserviceSearch;
